var KM = KM || {
  vendor: 'King \u0026 McGaw'
}

if (!KM.isPodProduct) {
  KM.isPodProduct = function (product) {
    if (product && product.vendor) {
      return product.vendor === KM.vendor
    }
  }
}

if (!KM.initialize) {
  KM.initialize = function (options) {
    this.product = options.product || {}
    this.variantMetafields = options.variantMetafields || {}
    this.frameSelections = options.frameSelections || {}
    this.framePicker = $('.pod-frame-picker').first()
    this.shopifyFrameSelector = {}
    this.toTitleCase = function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    }
  }
}

if (!KM.buildFramePicker) {
  KM.buildFramePicker = function (size) {
    this.framePicker = $('.pod-frame-picker')
    this.framePicker.html('')
    var frameDivs = []
    var shopifyFrameSelectorElement = this.shopifyFrameSelector
    this.frameSelections[size].forEach(function (frame) {
      var cssClass = $(shopifyFrameSelectorElement).val() === frame.label ? 'frame current' : 'frame'
      var $frameDiv = $(
        '<li class="' +
          cssClass +
          '" data-frame-value="' +
          frame.label +
          '" data-frame-id="' +
          frame.frame_id +
          '"><img src="' +
          frame.image +
          '" alt="' +
          frame.label +
          '" alt="' +
          frame.title +
          '" title="' +
          frame.title +
          '" /></li>'
      )
      frameDivs.push($frameDiv)
    })
    var cssClass = $(shopifyFrameSelectorElement).val() === 'none' ? 'frame current' : 'frame'
    frameDivs.push($('<li class="' + cssClass + '" data-frame-value="none"><div class="no-frame">no frame</div></li>')) // no frame
    this.framePicker.append(frameDivs).show()
    $(shopifyFrameSelectorElement).hide()

    this.framePicker.find('.frame').click($.proxy(this.selectFrame, this))
  }
}

if (!KM.handlePODSelection) {
  KM.handlePODSelection = function (product, variant) {
    if (!KM.isPodProduct(product.productSingleObject)) {
      return true
    }

    var typeSelector = product.$container.find('select[data-option=option1]').first()
    var sizeSelector = product.$container.find('select[data-option=option2]').first()
    this.shopifyFrameSelector = product.$container.find('select[data-option=option3]').first()
    var isCanvas = $(typeSelector).val() === 'unstretched canvas' || $(typeSelector).val() === 'stretched canvas'

    /*
     * workaround for variant sorting problem
     * extra small can't be the first variant as we don't want to default to it
     * so it's been ordered last, but we want it to appear first in the dropdown nonetheless
     */
    var extraSmallOption = $(sizeSelector).children("option[value='extra small']").first()
    if (extraSmallOption) {
      $(extraSmallOption).detach()
      $(sizeSelector).prepend($(extraSmallOption))
    }

    var selectedSize = $(sizeSelector).val()
    var isExtraSmall = selectedSize === 'extra small'

    var framesNotAvailable = isCanvas || _.isEmpty(this.frameSelections[selectedSize])

    if (!variant || !variant.available) {
      if (framesNotAvailable) {
        // ensure no frame is selected
        $(this.shopifyFrameSelector).val('none')
        $(this.shopifyFrameSelector).trigger('change')
        return false
      }
    }

    /*
     * can't have extra small canvas, can't have canvas if extra small
     */
    if (isExtraSmall) {
      $(typeSelector).find("option[value='stretched canvas']").prop('disabled', true)
      $(typeSelector).find("option[value='unstretched canvas']").prop('disabled', true)
    } else {
      $(typeSelector).find("option[value='stretched canvas']").prop('disabled', false)
      $(typeSelector).find("option[value='unstretched canvas']").prop('disabled', false)
    }
    if (isCanvas) {
      $(sizeSelector).find("option[value='extra small']").prop('disabled', true)
    } else {
      $(sizeSelector).find("option[value='extra small']").prop('disabled', false)
    }

    if (framesNotAvailable) {
      $(this.shopifyFrameSelector).parents('.selector-wrapper:first').hide()
      this.framePicker.hide()
    } else {
      $(this.shopifyFrameSelector).parents('.selector-wrapper:first').show()
      this.buildFramePicker($(sizeSelector).val())
    }

    var metaFields = this.variantMetafields[variant.id]
    $('#km-product-metadata .product-summary').html(this.toTitleCase(metaFields['product-description']))

    // Shopify, in it's infinite wisdom have decided to remove simple metafields. Dimensions are no longer
    // strings, but objects with a key & value. But we can't spend eternity reimporting every variant, so
    // instead the code will have to expect either one to be available and handle it accordingly
    if (metaFields['product-height']) {
      var productDimensions = `${metaFields['product-height'].value} x ${metaFields['product-width'].value} cm`
      $('#km-product-metadata .product-dimensions').html(productDimensions)

      var imageDimensions = `${metaFields['image-height'].value} x ${metaFields['image-width'].value} cm`
      $('#km-product-metadata .image-dimensions').html(imageDimensions)
    } else {
      $('#km-product-metadata .product-dimensions').html(metaFields['product-dimensions-cm'])
      $('#km-product-metadata .image-dimensions').html(metaFields['image-dimensions-cm'])
    }

    return true
  }
}

if (!KM.selectFrame) {
  KM.selectFrame = function (e) {
    var frameVal = $(e.currentTarget).data('frame-value')
    this.framePicker.find('.frame').removeClass('current')
    $(e.currentTarget).addClass('current')
    $(this.shopifyFrameSelector).val(frameVal)
    $(this.shopifyFrameSelector).trigger('change')
  }
}
